// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_66-6";
export var headerCell = "_66-2";
export var loadingStateContent = "_66-8";
export var rowWrapper = "_66-4";
export var stickyAggregationCell = "_66-b";
export var stickyAggregationRow = "_66-7";
export var stickyColumnCell = "_66-a";
export var stickyColumnHeaderCell = "_66-9";
export var table = "_66-1";
export var virtualRowWrapper = "_66-5";
export var virtualTableContainer = "_66-0";
export var white = "_66-3";